// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"486":"73e797a4","659":"158728ab","787":"1ed0c42c"}[chunkId] + ".chunk.js";
};